import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Redirect,
  Link,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteFilled,
  DeleteOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  MenuOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import {
  Spin,
  Row,
  Col,
  Button,
  Input,
  Breadcrumb,
  Form,
  message,
  Upload,
  Popover,
  Tooltip,
  Switch,
  Radio,
  Modal as AntdModal,
} from 'antd'
import '../../css/surgeon.scss'
import util from '../../util/util'
import {
  addEditSurgeon,
  getAccessCode,
  getSurgeon,
} from '../../store/action/surgeon.action'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import _, { set } from 'lodash'
import Modal from 'antd/lib/modal/Modal'
import serviceInterface from '../../services/service.interface'
import { constants } from '../../constants'
import { formatError } from 'graphql'
import profilelogo from '../../images/profile.jpg'
import { logout } from '../../store/action/profile.action'
import axios from 'axios'
import SessionStorage from '../../util/sessionstore'
import { parseYouTubeId, youTubeWatchUrl } from '../../util/welcomevideo'
import YouTubePreview from '../../component/youtubepreview/youtubepreview'

// const form = undefined;

const session = new SessionStorage()

var { ROLE } = constants

const ONLY_ADMINS = [
  ROLE.ADMIN,
  ROLE.COMPANY_ADMIN,
  ROLE.COMPANY_HEALTHCOACH,
  ROLE.SUPER_ADMIN,
]

const defaultTeam = [
  { _id: '1', name: 'Physician Assistants', details: '' },
  { _id: '2', name: 'Nurse Practitioners', details: '' },
  { _id: '3', name: 'Surgical Scheduler', details: '' },
  { _id: '4', name: 'Secretary', details: '' },
  { _id: '5', name: 'Medical Assistant', details: '' },
  { _id: '6', name: 'Practice Administrator', details: '' },
]

const SurgeonAdd = (props) => {
  var history = useHistory()
  var location = useLocation()
  var query = new URLSearchParams(location.search)
  var myprofile = query.get('myprofile')
  var form = useRef()

  const [surgeon, setSurgeon] = useState()
  const [disabled, setDisabled] = useState(true)
  const [order, setOrder] = useState(false)
  const [accesscode, setAccesscode] = useState('')
  const [image, setImage] = useState(undefined)
  const [showCatin, setCatin] = useState(false)
  const [cat, setCat] = useState()
  const [team, setTeam] = useState(
    JSON.parse(
      JSON.stringify(location.state ? location.state.team : defaultTeam)
    )
  )
  const [welcomeVideoAutoplay, setWelcomeVideoAutoplay] = useState(true)
  const [welcomeVideo, setWelcomeVideo] = useState('')
  const [videoUploading, setVideoUploading] = useState(false)
  // A provider has either an uploaded mp4 or a YouTube link, never both, so the
  // form tracks which one is active and only submits that one.
  const [videoSource, setVideoSource] = useState('file')
  const [youtubeInput, setYoutubeInput] = useState('')
  const [youtubeId, setYoutubeId] = useState('')
  const [youtubeError, setYoutubeError] = useState('')

  useEffect(() => {
    initializeForm()
  }, [])

  var initializeForm = async () => {
    setDisabled(
      !serviceInterface
        .AuthService()
        .authorize_role(ONLY_ADMINS, props?.decoded)
    )
    if (location.state || myprofile) {
      if (location.state) setSurgeon(location.state)
      else {
        var response = await props.getSurgeon(props.user?.surgeon)
        setSurgeon(response)
        setTeam(
          JSON.parse(JSON.stringify(response ? response.team : defaultTeam))
        )
      }
      var {
        phone,
        accesscode,
        image,
        _id,
        welcomevideo_autoplay,
        welcomevideo,
        welcomevideo_youtube_id,
      } = myprofile ? response : location.state
      if (_id == props?.user?.surgeon) setDisabled(false)
      setAccesscode(accesscode)
      setImage(image)
      setWelcomeVideoAutoplay(welcomevideo_autoplay !== false)
      if (welcomevideo) setWelcomeVideo(welcomevideo)
      if (welcomevideo_youtube_id) {
        // Stored as a bare id; show it back as the link the clinician pasted.
        setYoutubeId(welcomevideo_youtube_id)
        setYoutubeInput(youTubeWatchUrl(welcomevideo_youtube_id))
        setVideoSource('youtube')
      }
      if (myprofile) {
        form.current.setFieldsValue({
          ...response,
          public: formatNumber(phone.public),
          private: formatNumber(phone.private),
        })
        setTeamForm(response.team)
      } else {
        form.current.setFieldsValue({
          ...location.state,
          public: formatNumber(phone.public),
          private: formatNumber(phone.private),
        })
        setTeamForm()
      }
    } else {
      props.getAccessCode().then((data) => setAccesscode(data))
      form.current.setFieldsValue({ public: '', private: '' })
    }
  }

  var formatNumber = (phone) => {
    if (!phone) return ''
    var number = phone ? phone.toString() : ''
    if (number) {
      if (number.length > 10)
        number = number?.charAt(0) == '+' ? number : '+' + number
      else number = number?.charAt(0) == '+' ? '1' + number : '+1' + number
      return number
    }
  }

  var onDragEnd = (result) => {
    if (!result.destination) return
    var tms = _.orderBy(JSON.parse(JSON.stringify(team)), ['order'], ['asc'])
    tms.splice(
      result.destination.index,
      0,
      tms.splice(result.source.index, 1)[0]
    )
    var newTeam = tms.map((v, index) => {
      v.order = index + 1
      return v
    })
    setTeam(newTeam)
  }

  var handleChange = (info) => {
    if (info.file.status === 'done')
      util.getBase64(info.file.originFileObj, (image) => setImage(image))
  }

  var handleVideoUpload = (info) => {
    if (info.file.status === 'done') {
      setVideoUploading(true)
      const reader = new FileReader()
      reader.onload = async () => {
        try {
          const base64 = reader.result
          const surgeonId = surgeon?._id || 'new'
          const response = await axios.post(`${constants.API_URL}/upload/welcomevideo`, {
            video: base64,
            surgeonId,
          }, {
            headers: { 'x-authorization': 'Bearer ' + session.getProfile()?.token },
          })
          if (response.data.status === 'success') {
            setWelcomeVideo(response.data.filename)
            message.success('Video uploaded successfully')
          } else {
            message.error('Video upload failed')
          }
        } catch (error) {
          console.error('Video upload error:', error)
          message.error('Video upload failed')
        }
        setVideoUploading(false)
      }
      reader.readAsDataURL(info.file.originFileObj)
    }
  }

  var handleVideoDelete = async () => {
    if (!welcomeVideo) return
    try {
      await axios.delete(`${constants.API_URL}/upload/welcomevideo/${welcomeVideo}`, {
        headers: { 'x-authorization': 'Bearer ' + session.getProfile()?.token },
      })
    } catch (error) {
      console.error('Video delete error:', error)
    }
    setWelcomeVideo('')
  }

  var getVideoPreviewUrl = (filename) => {
    if (!filename) return ''
    if (filename.startsWith('http')) return filename
    return `${constants.API_URL}/content/${filename}`
  }

  var handleYoutubeChange = (e) => {
    var value = e.target.value
    setYoutubeInput(value)
    if (!value.trim()) {
      setYoutubeId('')
      setYoutubeError('')
      return
    }
    var id = parseYouTubeId(value)
    setYoutubeId(id || '')
    setYoutubeError(
      id
        ? ''
        : 'Enter a link to a single YouTube video (watch, youtu.be, shorts or embed link).'
    )
  }

  var clearYoutube = () => {
    setYoutubeInput('')
    setYoutubeId('')
    setYoutubeError('')
  }

  // Switching source clears the other one, so the form always shows exactly what
  // will be saved. Clearing an uploaded mp4 also removes it from disk.
  var handleVideoSourceChange = (nextSource) => {
    if (nextSource === videoSource) return
    var applySwitch = () => {
      if (nextSource === 'youtube') handleVideoDelete()
      else clearYoutube()
      setVideoSource(nextSource)
    }
    var discarding =
      nextSource === 'youtube' ? !!welcomeVideo : !!youtubeInput.trim()
    if (!discarding) {
      setVideoSource(nextSource)
      return
    }
    AntdModal.confirm({
      title: 'Replace the current video?',
      content:
        nextSource === 'youtube'
          ? 'The uploaded mp4 will be removed. A provider can have an uploaded video or a YouTube link, not both.'
          : 'The YouTube link will be removed. A provider can have an uploaded video or a YouTube link, not both.',
      okText: 'Replace',
      cancelText: 'Cancel',
      onOk: applySwitch,
    })
  }

  // Label and autoplay apply to whichever source is in use.
  var hasVideo = videoSource === 'youtube' ? !!youtubeId : !!welcomeVideo

  const NoVideoTooltip = ({ children }) => (
    <Tooltip
      title={
        hasVideo
          ? ''
          : videoSource === 'youtube'
          ? 'Please add a YouTube video link to enable this option.'
          : 'Please upload a welcome video to enable this option.'
      }
      placement='top'
      trigger={['hover', 'click']}
    >
      {children}
    </Tooltip>
  )

  var setTeamForm = (team_cats = team) => {
    // alert(JSON.stringify(team_cats))
    for (var i = 0; i < team_cats.length; i++) {
      form.current.setFieldsValue({
        [team_cats[i].name.toLowerCase().split(' ').join('_') + '_team']:
          team_cats[i].details,
      })
    }
  }

  var getTeam = (value) => {
    var cats = []
    for (var i = 0; i < team.length; i++) {
      cats.push({
        _id: team[i]._id?.length > 1 ? team[i]._id : undefined,
        name: team[i].name,
        details:
          value[team[i].name.toLowerCase().split(' ').join('_') + '_team'],
        order: team[i].order,
      })
    }
    return cats
  }

  var removeUnwantedValues = (input) => {
    for (var i = 0; i < team.length; i++)
      delete input[team[i].name.toLowerCase().split(' ').join('_') + '_team']
    delete input.public
    delete input.private
    return input
  }

  var handleSubmit = async (value) => {
    // A half-typed link is a mistake, not an intent to clear the video.
    if (videoSource === 'youtube' && youtubeInput.trim() && !youtubeId) {
      message.error('Please enter a valid YouTube video link before saving.')
      return
    }
    var input = JSON.parse(JSON.stringify(value))
    input.phone = {
      public: parseFloat(input.public),
      private: parseFloat(input.private),
    }
    // input.accesscode = accesscode;
    input.image = image
    input.customer = props.customer._id
    // Only the active source is sent; the server enforces the same exclusivity.
    input.welcomevideo = videoSource === 'file' ? welcomeVideo || '' : ''
    input.welcomevideo_youtube_id =
      videoSource === 'youtube' ? youtubeId || '' : ''
    if (input.welcomevideo || input.welcomevideo_youtube_id) {
      input.welcomevideo_autoplay = welcomeVideoAutoplay
    } else {
      input.welcomevideo_autoplay = false
      input.welcomevideo_label = ''
    }
    console.log(value)
    input.team = getTeam(value)
    input = removeUnwantedValues(input)
    console.log(input)
    let isLoginSurgeon=props.user?.email==surgeon?.email
   
    if (surgeon && isLoginSurgeon ) {
      emaiIdPrompt(input, surgeon?._id)
      return
    }
    var response = await props.addEditSurgeon(input, surgeon?._id)
    if (!response) return
    !myprofile && history.push('/surgeons')
  }

  const handleOk = async (input, surgeonid) => {
    var response = await props.addEditSurgeon(input, surgeonid)
    if (!response) return
    props.logoutapp()
  }
  const handleCancel = (input) => {
    form.current.setFieldsValue({ ...input, email: surgeon?.email })
  }

  var handleAddCat = () => {
    if (!cat || cat.trim() === '') return
    if (_.find(team, (v) => v.name.toLowerCase() == cat)) {
      setCat('')
      setCatin(false)
    } else {
      setTeam([...team, { name: cat, details: '' }])
      setCat('')
      setCatin(false)
    }
  }

  var handleRemoveCat = (name) => {
    var cats = JSON.parse(JSON.stringify(team))
    cats.splice(
      _.findIndex(cats, (v) => v.name == name),
      1
    )
    setTeam(cats)
  }

  const handlePreviewClick = () => {
    var path = window.location.pathname
    var search = location.search
    var url = window.location.href
      .replace(path, '/surgeon/')
      .replace(search, '')
      .replace('admin', 'profiles')
    var { _id } = surgeon
    window.open(url + _id)
  }

  const uploadButton = (
    <div className='uploadText'>
      <p className='ant-upload-drag-icon'>
        {/* <InboxOutlined /> */}
        <img
          src={profilelogo}
          height={100}
          width={100}
          className='profilelogo'
        />
      </p>
      <p className='ant-upload-text'>
        Click or drag file to this area to upload
      </p>
    </div>
  )

  var renderTeamTitles = () => {
    return team.map((v, index) => {
      return (
        <Draggable
          key={v?._id?.toString()}
          draggableId={v?._id?.toString()}
          index={index}
        >
          {(provided, snapshot) => (
            <div
              key={v?._id?.toString()}
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={{ ...provided.draggableProps.style }}
            >
              <Row className='reorder-row'>
                <Col>{v.name}</Col>
                <Col style={{ marginLeft: 'auto' }}>
                  <MenuOutlined />
                </Col>
              </Row>
            </div>
          )}
        </Draggable>
      )
    })
  }

  var renderOrderModal = () => (
    <Modal
      visible={order}
      onCancel={() => setOrder(false)}
      // title={"Re-order"}
      footer={false}
      className='surgeon-add-modal'
    >
      <Row align='middle' className='surgeon-modal-header'>
        <b>
          <i>*Drag tabs to reorder categories.*</i>
        </b>
      </Row>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId='droppable' direction='vertical'>
          {(provided, snapshot) => (
            <div
              ref={(e) => provided.innerRef(e)}
              {...provided.droppableProps}
              style={{ minHeight: 400 }}
            >
              {renderTeamTitles()}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  )

  var renderTeams = () => {
    return team.map((v) => {
      return (
        <Col flex='33%'>
          <Form.Item
            label={v.name}
            name={v.name.toLowerCase().split(' ').join('_') + '_team'}
            tooltip={{
              icon: (
                <DeleteFilled
                  style={{ cursor: disabled ? 'not-allowed' : undefined }}
                  onClick={() => !disabled && handleRemoveCat(v.name)}
                />
              ),
            }}
          >
            <Input.TextArea disabled={disabled} rows={3} />
          </Form.Item>
        </Col>
      )
    })
  }
  const emaiIdPrompt = async (input, surgeonid) => {
    AntdModal.confirm({
      title: 'Confirm',
      content:
        'You will be logged out for the recent changes to take effect. Would you like to continue?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleOk(input, surgeonid),
      onCancel: () => handleCancel(input),
    })
  }

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <Col className='surgeonAddContainer'>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to='/surgeons'>Providers</Link>
          </Breadcrumb.Item>
          {surgeon ? (
            <Breadcrumb.Item>Edit</Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item>Add</Breadcrumb.Item>
          )}
        </Breadcrumb>
      </Row>
      {/*<Row align="middle" className="headerRow">
                <Col className="headerText">SURGEON</Col>
                <Col>ACCESS CODE: </Col>
                <Col><Input disabled={disabled} className="accesscode" value={accesscode} onChange={(e) => setAccesscode(e.target.value.replace(/\s/g,''))} maxLength={20} /></Col>
            </Row>*/}
      <Form ref={form} layout={'vertical'} onFinish={handleSubmit}>
        <Row gutter={20}>
          <Col flex='33.33%'>
            <Form.Item
              label='Name'
              name='name'
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: 'Please enter name',
                },
              ]}
            >
              <Input disabled={disabled} maxLength={50} />
            </Form.Item>
            <Form.Item label='URL' name='url'>
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item
              label='Email'
              name='email'
              rules={[
                {
                  required: true,
                  whitespace: true,
                  type: 'email',
                  message: 'Please enter email',
                },
              ]}
            >
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item
              label='Phone - Private'
              name='private'
              rules={[
                () => ({
                  validator(rule, value) {
                    var number = value
                      ? value.charAt(0) == '+'
                        ? value
                        : '+' + value
                      : ''
                    if (!value || isValidPhoneNumber(number)) {
                      return Promise.resolve()
                    }
                    return Promise.reject('Please enter valid number!')
                  },
                }),
              ]}
            >
              <PhoneInput
                disabled={disabled}
                defaultCountry={'US'}
                className='phone-input'
                enableAreaCodes
              />
            </Form.Item>
            <Form.Item
              label='Phone - Public'
              name='public'
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: 'Please enter your number',
                },
                () => ({
                  validator(rule, value) {
                    var number = value
                      ? value.charAt(0) == '+'
                        ? value
                        : '+' + value
                      : ''
                    if (!value || isValidPhoneNumber(number)) {
                      return Promise.resolve()
                    }
                    return Promise.reject('Please enter valid number!')
                  },
                }),
              ]}
            >
              <PhoneInput
                disabled={disabled}
                defaultCountry={'US'}
                className='phone-input'
                enableAreaCodes
              />
            </Form.Item>
          </Col>
          <Col flex='33%'>
            <Form.Item
              label='About Me (max 300 words)'
              rules={[
                () => ({
                  validator(rule, value) {
                    var length = value ? value.split(' ').length : 0
                    if (length > 300)
                      return Promise.reject('Maximun 300 words!')
                    return Promise.resolve()
                  },
                }),
              ]}
              name='about_me'
            >
              <Input.TextArea
                disabled={disabled}
                style={{ height: 345 }}
                rows={15}
              />
            </Form.Item>
          </Col>
          <Col flex='33.33%'>
            <Row justify='center'>
              <Form.Item
                label={'Photo'}
                name='image'
                rules={[
                  { required: false, message: 'Please upload your image' },
                ]}
              >
                <Upload.Dragger
                  disabled={disabled}
                  listType='picture-card'
                  showUploadList={false}
                  onChange={handleChange}
                  customRequest={({ file, onSuccess }) =>
                    setTimeout(() => onSuccess('ok'), 0)
                  }
                >
                  {image ? (
                    <img
                      className='uploadPrev'
                      src={image}
                      alt='avatar'
                      style={{ width: '100%' }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload.Dragger>
              </Form.Item>
            </Row>

            <Row justify='center'>
              {' '}
              {image && (
                <DeleteOutlined style={{}} onClick={() => setImage('')} />
              )}
            </Row>
          </Col>
        </Row>
        <Row align='middle' className='headerRow'>
          <Col className='headerText'>Hospital</Col>
        </Row>
        <Row gutter={20}>
          <Col flex={'33.33%'}>
            <Form.Item label='Hospital - Name' name='hospital_name'>
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item label='Hospital - URL' name='hospital_url'>
              <Input disabled={disabled} />
            </Form.Item>
          </Col>
          <Col flex={'33.33%'}>
            <Form.Item label='Department - Name' name='department_name'>
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item label='Department - Title' name='department_title'>
              <Input disabled={disabled} />
            </Form.Item>
          </Col>
          <Col flex={'33.33%'}>
            <Form.Item label='Address' name='address'>
              <Input.TextArea
                disabled={disabled}
                style={{ height: 110 }}
                rows={5}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row align='middle' className='headerRow'>
          <Col className='headerText'>Video Message</Col>
        </Row>
        <Row gutter={20}>
          <Col flex={'100%'}>
            <Form.Item
              label='Video Source'
              tooltip='A provider can show an uploaded mp4 or a YouTube video, not both'
            >
              <Radio.Group
                disabled={disabled}
                value={videoSource}
                onChange={(e) => handleVideoSourceChange(e.target.value)}
              >
                <Radio value='file'>Upload mp4 file</Radio>
                <Radio value='youtube'>YouTube link</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col flex={'50%'}>
            {videoSource === 'youtube' ? (
              <Form.Item
                label='YouTube Video Link'
                tooltip='Paste a link to a single YouTube video, e.g. https://www.youtube.com/watch?v=xxxxxxxxxxx'
                validateStatus={youtubeError ? 'error' : undefined}
                help={youtubeError || undefined}
              >
                <Input
                  disabled={disabled}
                  value={youtubeInput}
                  onChange={handleYoutubeChange}
                  placeholder='https://www.youtube.com/watch?v=...'
                  allowClear
                />
                {youtubeId && (
                  <div style={{ marginTop: 8 }}>
                    <YouTubePreview videoId={youtubeId} />
                    <Row justify='center' style={{ marginTop: 8 }}>
                      <DeleteOutlined
                        style={{
                          fontSize: 18,
                          color: '#ff4d4f',
                          cursor: 'pointer',
                        }}
                        onClick={clearYoutube}
                      />
                    </Row>
                  </div>
                )}
              </Form.Item>
            ) : (
              <Form.Item
                label='Upload Video (mp4)'
                tooltip='Drag and drop or click to upload an mp4 video file'
              >
                {welcomeVideo ? (
                  <div>
                    <video
                      src={getVideoPreviewUrl(welcomeVideo)}
                      controls
                      style={{
                        width: '100%',
                        maxHeight: 300,
                        background: '#000',
                      }}
                    />
                    <Row justify='center' style={{ marginTop: 8 }}>
                      <DeleteOutlined
                        style={{
                          fontSize: 18,
                          color: '#ff4d4f',
                          cursor: 'pointer',
                        }}
                        onClick={handleVideoDelete}
                      />
                    </Row>
                  </div>
                ) : (
                  <Upload.Dragger
                    disabled={disabled || videoUploading}
                    accept='.mp4'
                    showUploadList={false}
                    onChange={handleVideoUpload}
                    customRequest={({ file, onSuccess }) =>
                      setTimeout(() => onSuccess('ok'), 0)
                    }
                  >
                    <p className='ant-upload-drag-icon'>
                      <InboxOutlined />
                    </p>
                    <p className='ant-upload-text'>
                      {videoUploading
                        ? 'Uploading video...'
                        : 'Click or drag mp4 file to upload'}
                    </p>
                  </Upload.Dragger>
                )}
              </Form.Item>
            )}
          </Col>
          <Col flex={'30%'}>
            <Form.Item
              label='Video Label'
              name='welcomevideo_label'
              tooltip={hasVideo
                ? 'This label will be shown to patients above the video'
                : undefined}
            >
              <NoVideoTooltip>
                <span style={{ display: 'inline-block', width: '100%' }}>
                  <Input
                    disabled={disabled || !hasVideo}
                    placeholder='A message from your provider'
                    style={!hasVideo ? { pointerEvents: 'none' } : undefined}
                  />
                </span>
              </NoVideoTooltip>
            </Form.Item>
          </Col>
          <Col flex={'20%'}>
            <Form.Item label='Autoplay Video'>
              <NoVideoTooltip>
                <span style={{ display: 'inline-block' }}>
                  <Switch
                    disabled={disabled || !hasVideo}
                    checked={hasVideo ? welcomeVideoAutoplay : false}
                    onChange={(checked) => setWelcomeVideoAutoplay(checked)}
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    style={!hasVideo ? { pointerEvents: 'none' } : undefined}
                  />
                </span>
              </NoVideoTooltip>
            </Form.Item>
          </Col>
        </Row>
        <Row align='middle' className='headerRow'>
          <Col className='headerText'>Team</Col>
          <Col>
            <Button
              disabled={disabled}
              type='default'
              onClick={() => setOrder(true)}
            >
              Re-order
            </Button>
          </Col>
        </Row>
        <Row gutter={20}>
          {renderTeams()}
          <Col flex='33.33%'>
            <Row>
              {!showCatin ? (
                <Button
                  disabled={disabled}
                  style={{ marginTop: 22 }}
                  onClick={() => setCatin(true)}
                  type='ghost'
                  icon={<PlusOutlined />}
                >
                  Add Category
                </Button>
              ) : (
                <Col flex='auto'>
                  <Row align='middle' justify='center' gutter={5}>
                    <Col flex='88%'>
                      <Input
                        disabled={disabled}
                        value={cat}
                        onChange={(e) => setCat(e.target.value)}
                        placeholder='Enter Category'
                      />
                    </Col>
                    <Col flex='auto'>
                      <CloseCircleOutlined
                        style={{ fontSize: 18 }}
                        onClick={() => setCatin(false)}
                      />
                    </Col>
                    <Col flex='auto'>
                      <CheckCircleOutlined
                        style={{ fontSize: 18 }}
                        onClick={handleAddCat}
                      />
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        {!surgeon && (
          <>
            <br />
            <Row>
              <b>
                <i>*User will receive an email to set their password.*</i>
              </b>
            </Row>{' '}
          </>
        )}
        <Row justify='end'>
          <Form.Item>
            <Button
              hidden={!myprofile}
              type='primary'
              className='submit-form-button'
            >
              <a
                href={constants.API_URL + '/qrcode/' + surgeon?._id + '/-1'}
                target='_blank'
              >
                Download qrcode
              </a>
            </Button>
            <Button
              disabled={!surgeon?._id}
              style={{ marginLeft: 20 }}
              onClick={handlePreviewClick}
              type='primary'
              className='submit-form-button'
              icon={
                <Tooltip
                  trigger={'hover'}
                  title={'Save the changes to see them in the preview.'}
                >
                  <InfoCircleOutlined />
                </Tooltip>
              }
            >
              Preview
            </Button>
            <Button
              disabled={disabled}
              style={{ marginLeft: 20 }}
              type='primary'
              htmlType='submit'
              className='submit-form-button'
            >
              {surgeon ? 'Update' : 'Add'}
            </Button>
            <Button
              hidden={myprofile}
              style={{ marginLeft: 20 }}
              type='primary'
              className='submit-form-button'
            >
              <Link to={'/surgeons'}>Cancel</Link>
            </Button>
          </Form.Item>
        </Row>
      </Form>
      {renderOrderModal()}
    </Col>
  )
}

SurgeonAdd.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    decoded: util.verifyToken(state.profile.token, true),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    user: state.profile?.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAccessCode: () => dispatch(getAccessCode()),
    addEditSurgeon: (input, id) => dispatch(addEditSurgeon(input, id)),
    logoutapp: () => dispatch(logout()),
    getSurgeon: (id) => dispatch(getSurgeon(id, true)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SurgeonAdd)
